import React from 'react';
import { CheckCircle, TrendingUp, Shield, Users, DollarSign, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
import offeringsImage from '../assets/medium-shot-people-sitting-together_23-2149271699.jpg_arrchf.jpg';

const Offerings = () => {
  const offerings = [
    'Diversified investment portfolios across multiple asset classes',
    'Professional wealth management and financial planning services',
    'Real-time market analysis and investment recommendations',
    'Secure and regulated trading platforms with advanced features',
    'Personalized investment strategies tailored to your goals',
    'Expert guidance from certified financial advisors',
    '24/7 customer support and account management',
    'Competitive fees and transparent pricing structure'
  ];

  const features = [
    {
      icon: TrendingUp,
      title: 'High Returns',
      description: 'Maximize your investment potential with our strategic approach'
    },
    {
      icon: Shield,
      title: 'Secure Platform',
      description: 'Your investments are protected with bank-level security'
    },
    {
      icon: Users,
      title: 'Expert Team',
      description: 'Access to experienced financial professionals'
    },
    {
      icon: Clock,
      title: 'Quick Processing',
      description: 'Fast and efficient transaction processing'
    }
  ];

  return (
    <section className="relative pt-8 pb-20 bg-gradient-to-br from-gray-50 to-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold font-serif text-navy-900 mb-6">
            What We Offer
            <span className="text-gradient block">You</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            At Hula Capital, we offer comprehensive investment solutions designed 
            to help you achieve your financial goals with confidence and security.
          </p>
        </div>

        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-16">
          {/* Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-500">
              <img
                src={offeringsImage}
                alt="What We Offer"
                className="w-full h-96 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-navy-900/50 to-transparent"></div>
            </div>
          </div>

          {/* Content */}
          <div>
            <h3 className="text-3xl font-bold text-navy-900 mb-8">
              Comprehensive Financial Solutions
            </h3>
            <div className="space-y-4">
              {offerings.map((offering, index) => (
                <div key={index} className="flex items-start space-x-3 group">
                  <div className="flex-shrink-0 mt-1">
                    <CheckCircle className="h-5 w-5 text-gold-500 group-hover:scale-110 transition-transform duration-300" />
                  </div>
                  <p className="text-gray-600 leading-relaxed">{offering}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <div key={index} className="text-center group bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
                <div className="inline-flex p-4 bg-gradient-to-r from-gold-500 to-gold-600 rounded-xl mb-4 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                  <IconComponent className="h-8 w-8 text-white" />
                </div>
                <h4 className="text-xl font-bold text-navy-900 mb-3">
                  {feature.title}
                </h4>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>


      </div>
      
      {/* Bottom Wave */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden">
        <svg className="relative block w-full h-24" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <defs>
            <linearGradient id="offeringsWaveGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" style={{stopColor: '#f8fafc', stopOpacity: 1}} />
              <stop offset="25%" style={{stopColor: '#f1f5f9', stopOpacity: 1}} />
              <stop offset="75%" style={{stopColor: '#e2e8f0', stopOpacity: 1}} />
              <stop offset="100%" style={{stopColor: '#cbd5e1', stopOpacity: 1}} />
            </linearGradient>
          </defs>
          <path 
            d="M0,40 C200,120 400,20 600,60 C800,100 1000,20 1200,50 L1200,120 L0,120 Z" 
            fill="url(#offeringsWaveGradient)"
          />
        </svg>
      </div>
    </section>
  );
};

export default Offerings; 